<template>
  <button type="button" class="insight-card" @click="$emit('open')">
    <div class="insight-header">
      <font-awesome-icon :icon="icon" class="insight-icon" />
      <h3>{{ title }}</h3>
      <font-awesome-icon icon="arrow-right" class="insight-arrow" />
    </div>

    <div v-if="loading" class="insight-loading">Loading…</div>
    <ul v-else class="insight-stats">
      <li v-for="stat in stats" :key="stat.label" class="insight-stat">
        <span class="insight-value" :class="stat.tone ? `tone-${stat.tone}` : ''">{{ stat.value }}</span>
        <span class="insight-label">{{ stat.label }}</span>
      </li>
    </ul>
  </button>
</template>

<script>
export default {
  name: 'InsightCard',
  props: {
    title: { type: String, required: true },
    icon: { type: [String, Array], default: 'circle-info' },
    // [{ label, value, tone? }] - tone: 'good' | 'warning' | 'critical'
    stats: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  emits: ['open'],
};
</script>

<style scoped>
.insight-card {
  display: flex;
  flex-direction: column;
  gap: 14px;
  background: var(--surface-1);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 16px 18px;
  box-shadow: 0 1px 2px rgba(11, 11, 11, 0.04);
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
  transition: box-shadow 0.15s ease, border-color 0.15s ease, transform 0.15s ease;
}

.insight-card:hover {
  box-shadow: 0 6px 16px rgba(11, 11, 11, 0.08);
  border-color: var(--series-1);
  transform: translateY(-1px);
}

.insight-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.insight-icon {
  color: var(--series-1);
  font-size: 15px;
  flex-shrink: 0;
}

.insight-header h3 {
  flex: 1;
  margin: 0;
  font-size: 14.5px;
  font-weight: 700;
  color: var(--text-primary);
}

.insight-arrow {
  color: var(--text-muted);
  font-size: 12px;
  transition: transform 0.15s ease;
}

.insight-card:hover .insight-arrow {
  transform: translateX(3px);
  color: var(--series-1);
}

.insight-loading {
  font-size: 13px;
  color: var(--text-muted);
}

.insight-stats {
  list-style: none;
  display: flex;
  gap: 18px;
  margin: 0;
  padding: 0;
}

.insight-stat {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.insight-value {
  font-size: 22px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--text-primary);
}

.insight-value.tone-good {
  color: var(--status-good);
}

.insight-value.tone-warning {
  color: #a06c00; /* --status-warning is too light for text on white */
}

.insight-value.tone-critical {
  color: var(--status-critical);
}

.insight-label {
  font-size: 12px;
  color: var(--text-muted);
}
</style>
